import { makeSlots } from '../utils'
function getSlots(key, fields) {
    fields = fields || {}
    const slots = fields[key] || {}
    const obj = {}
    Object.keys(slots).forEach((key) => {
        obj[key] = makeSlots(slots[key])
    })
    return obj
}
export default {
    computed: {
        slots() {
          return getSlots('slots', this.field)
        },
        scopedSlots() {
            return getSlots('scopedSlots', this.field)
        },
    },
    methods: {
        separateSlot() {
            const { _normalized, ...other_scoped_slots} = this.scopedSlots || {}
            return other_scoped_slots
        }
    }
}